<template>
  <w-loader v-if="v5services.loading" size="small"/>
  <div v-else-if="transaction_amount" class="gap-20 d-flex flex-column" data-test-id="">
    <div class="w-subtitle-1">{{ $l.t('p-methods.choose-amount', 'Choose amount') }}</div>
    <w-radio-group
      v-model="payment_type"
      hide-details="auto"
      data-test-id=""
    >
      <v-radio
        :label="$l.t('p-methods.pay-in-full', 'Pay in full {}', [formatMoney(transaction_amount)])"
        value="full"
        color="text lighten-1"
        type="radio"
        class="mb-5"
      />
      <v-radio
        :label="$l.t('app.other', 'Other')"
        value="other"
        color="text lighten-1"
        type="radio"
      />
    </w-radio-group>
    <w-text-field
      v-model="pay_amount"
      type="number"
      :placeholder="$l.t('p-methods.enter-an-amount', 'Enter an amount')"
      :disabled="payment_type === 'full'"
      :key="payment_type"
    ></w-text-field>
    <w-btn
      @click="openPaymentModal"
      :disabled="transaction_amount === 0 || (payment_type === 'other' && !pay_amount)"
      :key="pay_amount"
      class="mt-4 d-flex mx-auto"
      color="primary"
    >
      {{ $l.t('p-methods.make-a-payment', 'Make a Payment') }}
    </w-btn>
    <DefaultModal v-model="choose_payment_card" width="500" @close="clearChosenCard()">
      <div class="w-body-1 mb-6 text-center light-bold">
        {{ $l.t('billing.choose-a-card-for-making-the-payment', 'Choose a card for making the payment.') }}
      </div>
      <div v-for="(card, i) of p_method.items" class="mb-4" :key="i">
        <CreditCard
          :card="card"
          :hide_primary="true"
          @click="chosen_card = card"
          :class="{'selected-card': chosen_card && chosen_card.id === card.id}"
          class="cursor-pointer"
        />
      </div>
      <template v-slot:buttons>
        <w-btn color="secondary" @click.prevent="choose_payment_card = false; clearChosenCard();">{{ $l.t('app.cancel', 'Cancel') }}</w-btn>
        <w-btn color="primary" @click.prevent="choose_payment_card = false; make_payment = true" :disabled="!chosen_card">{{ $l.t('p-methods.select-card', 'Select card') }}</w-btn>
      </template>
    </DefaultModal>
    <DefaultModal v-model="make_payment" width="350" class="pay-modal" @close="clearChosenCard()">
      <div class="w-body-1">
        {{ $l.t('p-methods.you-are-making-a-payment', 'You are making a payment of {} with credit card ending in [{}]. Would you like to continue?', [formatMoney(payment_type === 'full' ? transaction_amount : pay_amount), chosen_card ? chosen_card.details.last4 : '']) }}
      </div>
      <template v-slot:buttons>
        <w-btn color="secondary" @click.prevent="make_payment = false; clearChosenCard()" class="cancel">{{ $l.t('app.cancel', 'Cancel') }}</w-btn>
        <w-btn color="primary" @click.prevent="makePayment">{{ $l.t('app.yes', 'Yes') }}</w-btn>
      </template>
    </DefaultModal>
  </div>
</template>

<script>
import V5Services from '../../models/V5Services';
import CreditCard from './CreditCard.vue';
import DefaultModal from './modal/DefaultModal.vue';

export default {
  props: ['p_method'],
  components: {
    CreditCard,
    DefaultModal,
  },
  data() {
    return {
      v5services: new V5Services(this.$session),
      primary_change_confirmation: false,
      choose_payment_card: false,
      transaction_amount: 0,
      payment_type: 'full',
      make_payment: false,
      billing_info: null,
      chosen_card: null,
      pay_amount: null,
    };
  },
  async created() {
    await this.fetchAmount();
    if (this.$props.p_method.items.length === 1) {
      this.$data.chosen_card = this.$props.p_method.items[0];
    }
  },
  methods: {
    formatMoney(val) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      return formatter.format(val);
    },
    formatAmount(str) {
      return parseFloat(str.replace(/[$,]/g, ''));
    },
    clearChosenCard() {
      if (this.$props.p_method.items?.length !== 1) {
        setTimeout(() => this.$data.chosen_card = null, 200);
      }
    },
    async makePayment() {
      this.$data.make_payment = false;
      const amount = parseInt(this.$data.payment_type === 'full' ? this.$data.transaction_amount : this.$data.pay_amount * 100);
      await this.$props.p_method.make_payment(amount, this.$data.chosen_card.id);
      this.$data.pay_amount = 0;
      await this.fetchAmount();
    },
    openPaymentModal() {
      if (!this.$data.chosen_card) {
        return this.$data.choose_payment_card = true;
      }
      return this.$data.make_payment = true;
    },
    async fetchAmount() {
      this.$data.billing_info = await this.$data.v5services.get_billing_info();
      this.$data.transaction_amount = this.formatAmount(this.$data.billing_info.cb_current_balance) - this.formatAmount(this.$data.billing_info.ps_payments) - this.formatAmount(this.$data.billing_info.ps_adjustments);
    }
  },
};
</script>

<style scoped>
.w-subtitle-1 {
  color: #197f9f;
}
.selected-card {
  border: 2px solid #364047 !important;
}
</style>
